import { IconButton, IconButtonProps } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { SxProps, Theme } from '@mui/system';

type InfoIconButtonProps = {
  'aria-label': string;
  onClick: () => void;
  fontSize?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
} & Pick<IconButtonProps, 'size' | 'disabled'>;

export default function InfoIconButton({
  'aria-label': ariaLabel,
  onClick,
  fontSize = 'small',
  sx,
  size = 'small',
  disabled,
}: InfoIconButtonProps): JSX.Element {
  return (
    <IconButton
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      size={size}
      disabled={disabled}
      sx={{
        p: 0.25,
        '&:focus-visible': {
          outline: '2px solid #153760',
          outlineOffset: '2px',
        },
        ...sx,
      }}>
      <InfoOutlinedIcon color="info" fontSize={fontSize} aria-hidden="true" />
    </IconButton>
  );
}
